import {
  Table,
  TableCell,
  TableContainer,
  TablePagination,
  TableProps,
  TableRow,
  TableRowProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledTableRowProps extends TableRowProps {
  withDivider?: boolean;
  noStartDivider?: boolean;
  keepSticky?: boolean;
  inactive?: boolean;
}

const CustomTableRow = styled(TableRow, {
  shouldForwardProp: (prop: string) =>
    !['withDivider', 'keepSticky', 'noStartDivider', 'inactive'].includes(prop),
})<StyledTableRowProps>(
  ({ withDivider, noStartDivider, keepSticky, inactive, theme }) => ({
    height: '3rem',
    ...(withDivider && {
      '& th:not(:last-of-type)': {
        position: keepSticky ? 'sticky' : 'relative',
      },
      '& th:not(:last-of-type)::after': {
        content: '""',
        display: 'block',
        width: 2,
        height: 14,
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        background: theme.palette.light.main,
      },
      ...(noStartDivider && {
        '& th:first-of-type::after': {
          display: 'none!important',
        },
      }),
    }),
    ...(inactive && {
      background: theme.palette.light.extraLight,
      '.MuiTableCell-root': { color: theme.palette.secondary.extraLight },
    }),
  })
);

const CustomTableContainer = styled(TableContainer)(({ theme }) => ({
  flex: '1 0 auto',
  height: 0,
  // display: 'flex',
  // flexDirection: 'column',
  // flex: '1 0 auto',  // height: '100%',
}));

interface StyledTableProps extends TableProps {
  fullHeight?: boolean;
}

const CustomTable = styled(Table, {
  shouldForwardProp: (prop: string) => !['fullHeight'].includes(prop),
})<StyledTableProps>(({ fullHeight }) => ({
  ...(fullHeight && {
    minHeight: '100%',
  }),
}));

const CustomTableHeadCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.light.dark,
  fontWeight: 700,
}));

const CustomTableCell = styled(TableCell)(({ theme }) => ({
  padding: '0.25rem 1rem',
  color: theme.palette.secondary.main,
}));

const CustomPinnedTableCell = styled(TableCell)(({ theme }) => ({
  padding: '0.25rem 0.5rem',
  position: 'sticky',
  right: 0,
  backgroundColor: theme.palette.background.paper,
  borderLeft: `1px solid  ${theme.palette.divider}`,
  zIndex: 1,
}));

const CustomTablePagination = styled(TablePagination)(({ theme }) => ({
  '.MuiTablePagination-selectLabel': {
    color: theme.palette.secondary.light,
    fontSize: '0.75rem',
    letterSpacing: '0.4px',
  },
  '.MuiTablePagination-toolbar': {
    color: theme.palette.secondary.main,
  },
  '.MuiTablePagination-select, .MuiTablePagination-displayedRows': {
    fontSize: '0.75rem',
  },
})) as typeof TablePagination;

export {
  CustomTableContainer,
  CustomTable,
  CustomTableRow,
  CustomTableHeadCell,
  CustomTableCell,
  CustomPinnedTableCell,
  CustomTablePagination,
};
